import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import state from '../../features/CompanycodeTranslation/components/state';
const INITIAL_STATE = {
  loginStatus: false,
  isGoogleUserLoginCompleted: false,
  isLogingOut: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState: INITIAL_STATE,
  reducers: {
    logIn: (state) => {
      state.loginStatus = true;
    },
    LogoutStart: (state) => {
      state.isLogingOut = true;
    },
    setGoogleUserLoginCompleted: (state) => {
      state.isGoogleUserLoginCompleted = true;
    },
    logOut: (state) => {
      state.loginStatus = false;
      const broadcastChannel = new BroadcastChannel('my-logout-channel');
      broadcastChannel.postMessage({ type: 'logout' });
    },
    logOutx: (state) => {
      state.loginStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { logIn, logOut, logOutx, setGoogleUserLoginCompleted,LogoutStart } = loginSlice.actions;

export default loginSlice.reducer;
